/**
 * Your Components
 */
import VeeValidate from "vee-validate";
import VueMatchHeights from "vue-match-heights";
import Toasted from "vue-toasted";
import numeral from "numeral";

Vue.component("social-share-button", () => import("./social/SocialShareButton"));
Vue.component("product-search", () => import("./product-search/ProductSearch"));
Vue.component("product-view", () => import("./product/ProductView"));
Vue.component("cart-qty-input", () => import("./cart/CartQtyInput"));
Vue.component("itemcount-component", () => import("./cart/ItemCountComponent"));
Vue.component("checkout-status", () => import("./checkout/CheckoutStatus"));
Vue.component("blog-list", () => import("./blog/BlogList"));
Vue.component("cart-preview-dropdown", () => import("./cart/CartPreviewDropdown"));
Vue.component("product-family", () => import("./product/ProductFamily"));

/**
 * External Components. eg. Packages
 */
Vue.use(VeeValidate);

Vue.use(VueMatchHeights, {});

Vue.use(Toasted, {
  theme: "outline",
  duration: 2000,
  action: [
    {
      text: "close",
      onClick: (e, toastObject) => {
        toastObject.goAway(0);
      }
    }
  ],
  iconPack: "fontawesome"
});

Vue.filter("priceFormat", function(value) {
  return numeral(value).format("0,0.00");
});

Vue.filter("moneyToCurrencyFormat", function({ amount, currency }) {
  return currency + " " + numeral(amount / 100).format("0,0.00");
});

Vue.filter("moneyToDecimal", function({ amount }) {
  return parseFloat(amount / 100);
});
